import { render, staticRenderFns } from "./InvalidTripleDialog.vue?vue&type=template&id=df2d3500&lang=pug&"
import script from "./InvalidTripleDialog.vue?vue&type=script&lang=ts&"
export * from "./InvalidTripleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports